import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useOfficialDailyDispatch } from "./official-daily-context";
import { IListOfficialDailyRequest } from "../../../model/base/request/list-official-daily-request";

export const useOfficialDailyController = () => {
    const OfficialDailyDispatch = useOfficialDailyDispatch();
    
    async function loadData(request: IListOfficialDailyRequest) {
        try {
            // Limpa os dados antes de carregar novos
            OfficialDailyDispatch({
                type: ACTION_TYPES.clearData,
            });
            const result = await PortalAppService.listOfficialDaily(request);
            OfficialDailyDispatch({
                type: ACTION_TYPES.loadingData,
                payload: result,
            });
        } catch (error) {
            console.log(error);
        }
    }
    return {
        loadData
    };
}


